import "./LegalLinks.css";

const LEGAL_LINKS = [
  { label: "Terms of Use", href: "/Terms_of_use" },
  { label: "Privacy Policy", href: "/Privacy_Policy" },
  { label: "Copyright & Music Policy", href: "/Copyright_music_policy" },
  { label: "Community Guidelines", href: "/Boloindia_Community_Guidelines" },
  { label: "Delete Account", href: "/Login" },
];

export default function LegalLinks({ className = "" }) {
  return (
    <nav className={`hero__legal ${className}`.trim()}>
      {LEGAL_LINKS.map((link, i) => (
        <span key={link.href} className="hero__legal-item">
          <a href={link.href}>{link.label}</a>
          {i < LEGAL_LINKS.length - 1 && (
            <span className="hero__legal-sep">|</span>
          )}
        </span>
      ))}
    </nav>
  );
}
